import { useStore } from 'store/store';
import { useUtxEarnEnableEarn } from '@utx/utx-client';
import { useContext } from 'react';
import { useOffers } from '@/features/earn/hooks/useOffers.hook';
import { UserContext } from '@/user/user.context';

export const useDiscover = () => {
  const store = useStore();
  const isNewAccount = !store.users?.metadata.earnAccount?.enabled;

  const enableEarn = useUtxEarnEnableEarn();
  const { offers, offersByCategory, handleSearch, showMyAssetsOnly, toggleShowMyAssetsOnly } = useOffers({});
  const {
    offers: popularOffers,
    showMyAssetsOnly: showMyAssetsOnlyPopular,
    toggleShowMyAssetsOnly: toggleShowMyAssetsOnlyPopular
  } = useOffers({ tags: ['popular'] });

  const userContext = useContext(UserContext);

  function openAccount() {
    enableEarn.mutate(undefined, {
      onSuccess: () => {
        userContext.refresh();
      },
      onError: () => {}
    });
  }

  function refresh() {
    offers.refetch();
  }

  return {
    isLoading: offers.isLoading || offers.isFetching,
    enableEarnLoading: enableEarn.isLoading,
    isNewAccount,
    openAccount,
    handleSearch,
    refresh,
    offers,
    offersByCategory,
    popularOffers,
    isPopularOffersLoading: popularOffers.isLoading || popularOffers.isFetching,
    showAssets: {
      showMyAssetsOnly,
      toggleShowMyAssetsOnly
    },
    showAssetsPopular: {
      showMyAssetsOnly: showMyAssetsOnlyPopular,
      toggleShowMyAssetsOnly: toggleShowMyAssetsOnlyPopular
    },
    popularOffersLoading: popularOffers.isLoading || popularOffers.isFetching,
    offersLoading: offers.isLoading || offers.isFetching
  };
};
